import type { AppConfig } from './app.config';

// ── Shared configuration fragments ──────────────────────────────────────────

const firebase: AppConfig['firebase'] = {
	apiKey: 'AIzaSyDKAexSUkOIj63hP9MkLi22CHpykkh_4Bs',
	authDomain: 'notifyhallpass.firebaseapp.com',
	databaseURL: 'https://notifyhallpass.firebaseio.com',
	projectId: 'notifyhallpass',
	storageBucket: 'notifyhallpass.firebasestorage.app',
	messagingSenderId: '625620388494',
	appId: '1:625620388494:web:2205663799869a91',
	measurementId: 'G-FL5PERKEDZ',
};

const localizejs: AppConfig['localizejs'] = {
	apiKey: 'k2CZfKQ5Wqkbk',
};

const snowplow = {
	appId: 'smartpass-frontend',
	trackerNamespace: 'smartpass',
} as const;

const localSnowplow: AppConfig['snowplow'] = {
	...snowplow,
	enabled: true,
	collectorUrl: 'http://localhost:9090',
};

const prodSnowplow: AppConfig['snowplow'] = {
	...snowplow,
	enabled: true,
	collectorUrl: 'https://com-raptortechgcp-prod1.collector.snplow.net',
};

// ── Environment configurations ──────────────────────────────────────────────

const local: AppConfig = {
	basePath: '/',
	staticApiRoot: '',
	staticWsUrl: '',
	schoolOnboardApiRoot: 'http://localhost:8000/api/staging',
	discoveryBaseUrl: 'http://localhost:8055/api/discovery',
	firebase,
	localizejs,
	snowplow: localSnowplow,
	monitoring: {
		sentry: { enabled: false, environmentName: 'local' },
		enableNgrxStoreDevTools: true,
	},
	electricUrl: 'http://localhost:8787/',
	raptorUrl: 'https://test.raptortech.com/',
	raptorSmartpassUrl: 'https://test.raptortech.com/smartpass',
};

const localProd: AppConfig = {
	basePath: '/',
	staticApiRoot: 'http://localhost:8000/api/prod-us-central/',
	staticWsUrl: '',
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: localSnowplow,
	monitoring: {
		sentry: { enabled: false, environmentName: 'local-prod' },
		enableNgrxStoreDevTools: true,
	},
	raptorUrl: 'https://apps.raptortech.com/',
	raptorSmartpassUrl: 'https://apps.raptortech.com/smartpass',
};

const preview: AppConfig = {
	basePath: '/',
	staticApiRoot: '',
	staticWsUrl: '',
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: prodSnowplow,
	monitoring: {
		sentry: { enabled: true, environmentName: 'preview' },
		enableNgrxStoreDevTools: false,
	},
	raptorUrl: 'https://staging.raptortech.com/',
};

const production: AppConfig = {
	basePath: '/',
	staticApiRoot: '',
	staticWsUrl: '',
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: prodSnowplow,
	monitoring: {
		sentry: { enabled: true, environmentName: 'production' },
		enableNgrxStoreDevTools: false,
	},
	raptorUrl: 'https://apps.raptortech.com/',
	raptorSmartpassUrl: 'https://apps.raptortech.com/smartpass',
};

const raptorProduction: AppConfig = {
	basePath: '/smartpass',
	staticApiRoot: 'https://spapi.apps.raptortech.com/api/prod-us-central/',
	staticWsUrl: 'wss://spws.apps.raptortech.com/api/prod-us-central/v1/long_polling',
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: prodSnowplow,
	monitoring: {
		sentry: { enabled: true, environmentName: 'raptor-production' },
		enableNgrxStoreDevTools: false,
	},
	raptorUrl: 'https://apps.raptortech.com/',
	unauthorizedRedirectUrl: 'https://apps.raptortech.com/v7/unauthorized',
	auth0: {
		domain: 'login.raptortech.com',
		clientId: '6lndLHBY0w2HWrSStd9av60kN9q4QzX9',
		audience: 'https://api.raptortech.com',
		server: {
			api_root: 'https://spapi.apps.raptortech.com/api/prod-us-central/',
			domain: 'raptortech.com',
			icon_url: '',
			// Icon search is served from smartpass.app regardless of Raptor environment.
			// This URL is not added to Auth0's allowedList, so no bearer token is attached — the endpoint is unauthenticated.
			icon_search_url: 'https://smartpass.app/api/icons/search',
			name: 'Production',
			ws_url: 'wss://spws.apps.raptortech.com/api/prod-us-central/v1/long_polling',
		},
	},
};

const raptorStaging: AppConfig = {
	basePath: '/smartpass',
	staticApiRoot: 'https://spapi.staging.raptortech.com/api/staging/',
	staticWsUrl: 'wss://spws.staging.raptortech.com/api/staging/v1/long_polling',
	schoolOnboardApiRoot: 'https://smartpass.app/api/staging',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: prodSnowplow,
	monitoring: {
		sentry: { enabled: true, environmentName: 'raptor-staging' },
		enableNgrxStoreDevTools: false,
	},
	raptorUrl: 'https://staging.raptortech.com/',
	unauthorizedRedirectUrl: 'https://staging.raptortech.com/v7/unauthorized',
	auth0: {
		domain: 'staginglogin.raptortech.com',
		clientId: 'mWRv4pnUj1DoNFzw7UDaEXSEY0h3bhcn',
		audience: 'https://api-stag.raptortech.com',
		server: {
			api_root: 'https://spapi.staging.raptortech.com/api/staging/',
			domain: 'raptortech.com',
			icon_url: '',
			// Icon search is served from smartpass.app regardless of Raptor environment.
			// This URL is not added to Auth0's allowedList, so no bearer token is attached — the endpoint is unauthenticated.
			icon_search_url: 'https://smartpass.app/api/icons/search',
			name: 'Staging',
			ws_url: 'wss://spws.staging.raptortech.com/api/staging/v1/long_polling',
		},
	},
};

const raptorTest: AppConfig = {
	basePath: '/smartpass',
	staticApiRoot: '',
	staticWsUrl: '',
	schoolOnboardApiRoot: 'https://smartpass.app/api/prod-us-central',
	discoveryBaseUrl: 'https://smartpass.app/api/discovery',
	firebase,
	localizejs,
	snowplow: prodSnowplow,
	monitoring: {
		sentry: { enabled: true, environmentName: 'raptor-test' },
		enableNgrxStoreDevTools: false,
	},
	electricUrl: 'https://test.raptortech.com/electric-local/',
	raptorUrl: 'https://test.raptortech.com/',
	unauthorizedRedirectUrl: 'https://test.raptortech.com/v7/unauthorized',
	auth0: {
		domain: 'testlogin.raptortech.com',
		clientId: 'z163Bt6hV2a4VMLmlgh0F3xyldwPG9nv',
		audience: 'https://api-dev.raptortech.com',
		server: {
			api_root: 'https://spapi.test.raptortech.com/',
			domain: 'raptortech.com',
			icon_url: '',
			// Icon search is served from smartpass.app regardless of Raptor environment.
			// This URL is not added to Auth0's allowedList, so no bearer token is attached — the endpoint is unauthenticated.
			icon_search_url: 'https://smartpass.app/api/icons/search',
			name: 'Test',
			ws_url: 'wss://spws.test.raptortech.com/',
		},
	},
};

// ── Hostname resolution ─────────────────────────────────────────────────────

/**
 * Resolves the correct AppConfig based on the current hostname and port.
 * Called at app startup — no network request needed.
 */
export function resolveConfig(): AppConfig {
	const { hostname, port } = window.location;

	// Port-based overrides (before hostname matching)
	if ((hostname === 'localhost' || hostname === '127.0.0.1') && port === '4201') {
		return localProd;
	}

	// Hostname matching
	if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'local.smartpass.app') {
		return local;
	}
	if (hostname.endsWith('-dev.smartpass.app')) {
		return preview;
	}
	if (hostname === 'apps.raptortech.com') {
		return raptorProduction;
	}
	if (hostname === 'staging.raptortech.com') {
		return raptorStaging;
	}
	if (hostname === 'test.raptortech.com') {
		return raptorTest;
	}

	// Default fallback
	return production;
}
